module.exports = __webpack_public_path__ + "img/logo-general.287e198a.svg";